// Prescreening constants
export const QUESTION_MAPPING = {
    1: "Candidate's current salary including superannuation in AUD.",
    2: "Candidate's salary expectations for the job including superannuation in AUD.",
    3: "Candidate's work rights in Australia.",
    4: "Candidate's notice period in days.",
    5: "Candidate's first availability for an interview.",
    6: "Candidate's alternate availability for an interview.",
    7: "Is the candidate currently interviewing with other companies.",
    8: "If the candidate will accept fully remote work arrangements.",
    9: "If the candidate will accept hybrid work arrangements.",
    10: "If the candidate will accept fully in-person work arrangements.",
    11: "What is your location, city & suburb?",
    12: "Do you have your own transport?",
    13: "What is your hourly rate?",
    14: "What is your daily rate?",
    15: "What day are you available to start?",
    16: "What is your security clearance level?",
};

export const MAX_QUESTIONS = 4;
export const MAX_MESSAGE_LENGTH = 250;

export const DEFAULT_MESSAGE = `Hi {CandidateName},\nWe tried calling you about {JobTitle}.\nYou can contact {RecruiterEmail} for more details. \n\n- {RecruiterName}`;

export const VALID_VARIABLES = {
    '{CandidateName}': ['candidatename', 'candidate_name', 'candidate'],
    '{JobTitle}': ['jobtitle', 'job_title', 'job'],
    '{RecruiterName}': ['recruitername', 'recruiter_name', 'recruiter'],
    '{RecruiterEmail}': ['recruiteremail', 'recruiter_email', 'email']
};

// Simplified status mapping for prescreening
export const STATUS_MAP = {
    completed: {
        label: 'Call completed successfully',
        color: '#d4edda' // Green
    },
    ready: {
        label: 'Pre-screening completed',
        color: '#d4edda' // Green
    },
    busy: {
        label: 'Candidate was busy',
        color: '#f8d7da' // Red
    },
    silent: {
        label: 'No response during call',
        color: '#f8d7da' // Red
    },
    voicemail: {
        label: 'Call reached voicemail',
        color: '#f8d7da' // Red
    },
    hungup: {
        label: 'Candidate hung up during call',
        color: '#f8d7da' // Red
    },
    unreachable: {
        label: 'Phone number unreachable',
        color: '#f8d7da' // Red
    },
    missed: {
        label: 'Call was missed (no answer, no voicemail)',
        color: '#f8d7da' // Red
    },
    // NEW: Retry pending status (yellow) - when failed but not reached max retry
    retry_pending: {
        label: 'Call failed, retry pending',
        color: '#fff3cd' // Yellow
    },
    // Original failure statuses (red) - when reached max retry
    international_blocked: {
        label: 'International calling blocked',
        color: '#f8d7da' // Red
    },
    twilio_error: {
        label: 'Twilio service error',
        color: '#f8d7da' // Red
    },
    call_failed: {
        label: 'Call failed',
        color: '#f8d7da' // Red
    },
    pending: {
        label: 'Prescreening in progress',
        color: '#fff3cd' // Yellow
    },
    unknown: {
        label: 'Unknown status',
        color: '#d9d9d9' // Gray
    },
    none: {
        label: 'No prescreening started',
        color: '#d9d9d9' // Gray
    }
};
